import React, { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2';
import getChartDataGenericCall from '../../API/GenericAPICalls/getChartDataGenericCall';
import LoadingIcon from '../../../../Components/LoadingIcon/LoadingIcon';
import DownloadToExcelIcon from '../../../../Components/DownloadToExcelIcon/DownloadToExcelIcon';


const BarSeries02 = ({ config, keynumber, chartId, subuserId, usercode, filters, handleShow, handleClose, setSelectedChartIdDownload }) => {
    const [data, setData] = useState(null)
    const [chartConfiguration, setChartConfiguration] = useState(null)
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [title, setTitle] = useState("")
    const [cardStyle, setCardStyle] = useState({ height: 350, width: 350 })
    const [chartWidth, setChartWidth] = useState(300)
    const [chartHeight, setChartHeight] = useState(300)
    const [radialChartDivStyle, setRadialChartDivStyle] = useState({ display: 'flex', justifyContent: 'center' })
    const [legend, setLegend] = useState(null)
    const [labelsRadiusMultiplier, setLabelsRadiusMultiplier] = useState(1)
    const [labelsStyle, setLabelsStyle] = useState({})


    useEffect(() => {
        startUp()
    }, [config])

    useEffect(() => {
        deriveChartVarsFromChartCustomization()
    }, [chartConfiguration])

    const startUp = async () => {
        let validated = await validateAndSetConfig()
        if (validated) {
            let url = config.url
            let dataAPIResult = await getChartDataGenericCall(url, chartId, usercode, filters)
            setData(dataAPIResult.data)

        }
    }

    const COLORS = [
        '#4dc9f6',
        '#f67019',
        '#f53794',
        '#537bc4',
        '#acc236',
        '#166a8f',
        '#00a950',
        '#58595b',
        '#8549ba',
        '#e040fb', 
        '#ffa500', 
        '#008080'  
    ];


    const validateAndSetConfig = async () => {
        if (!config) {
            setError(true)
            setErrorText('No configuration passed to BarSeries01')
            return false
        }
        let cfg = await JSON.parse(config.chartCustomization)
        setChartConfiguration(cfg)
        return true
    }

    const deriveChartVarsFromChartCustomization = async () => {
        if (chartConfiguration) {
            if (chartConfiguration?.title) {
                setTitle(chartConfiguration.title.title)
            }
            if (chartConfiguration?.cardStyle) {
                setCardStyle(chartConfiguration.cardStyle)
            }
            if (chartConfiguration?.chartSize?.chartWidth) {
                setChartWidth(chartConfiguration.chartSize.chartWidth)
            }
            if (chartConfiguration?.chartSize?.chartHeight) {
                setChartHeight(chartConfiguration.chartSize.chartHeight)
            }
            if (chartConfiguration?.discreteColorLegend) {
                setLegend(chartConfiguration.discreteColorLegend)
            }
            if (chartConfiguration?.labelsRadiusMultiplier) {
                setLabelsRadiusMultiplier(chartConfiguration.labelsRadiusMultiplier)
            }
            if (chartConfiguration?.labelsStyle) {
                setLabelsStyle(chartConfiguration.labelsStyle)
            }
        }
    }

    const myData = [{ label: 'Super Custom label', angle: 1 }, { angle: 2, label: 'Super Custom label', subLabel: 'With annotation' }, { angle: 5, label: 'Alt Label' }, { angle: 3 }, { angle: 5, subLabel: 'Sub Label only' }]

    if (data && chartConfiguration && !error) {
        // console.log({ datasets: [{ data: data.map(item => item.y) }] })
        return (
            <div className='card card-chart d-inline-block m-1 p-3 ' style={cardStyle} key={keynumber}>
                <h5 className="card-title text-center">{title}</h5>
                {
                    config?.download && config?.download === "true" ?
                        <div className="d-flex flex-row-reverse"><DownloadToExcelIcon config={config} handleShow={handleShow} handleClose={handleClose} setSelectedChartIdDownload={setSelectedChartIdDownload} /></div>
                        : null
                }
                <div style={radialChartDivStyle}>
                    <Bar height={200} options={{ maintainAspectRatio: true }} data={{ labels: data.map(item => item.x), datasets: [{ label: 'shipments', data: data.map(item => item.y), backgroundColor: data.map((_, i) => COLORS[i]) }] }} />
                </div>
            </div>
        )
    } else if (error) {
        return (
            <div className='card d-inline-block m-3 p-2'>
                <div className=' d-flex justify-content-center align-items-center'>
                    Error: {errorText}
                </div>
            </div>
        )
    } else {
        return (
            <div className='card d-inline-block m-3 p-2'>
                <div className=' d-flex justify-content-center align-items-center'>
                    <LoadingIcon />
                </div>
            </div>
        )
    }
}

export default BarSeries02
